import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { media } from '../styles';

const propTypes = {
  children: PropTypes.any,
  gridGap: PropTypes.number,
  className: PropTypes.string,
  justifyContent: PropTypes.string,
  alignItems: PropTypes.string
};

const Grid = props => {
  const {
    className,
    children,
    gridGap = 24,
    mobileGap,
    justifyContent = 'normal',
    alignItems = 'normal',
    noWrap,
    awardGap = false,
  } = props;
  let items = React.Children.toArray(children);

  items.forEach((item, index) => {
    items[index] = React.cloneElement(item, { gridGap, mobileGap });
  });
  return (
    <GridWrapper className={className} awardGap={awardGap}>
      <StyledGrid
        className={noWrap ? 'no-wrap' : ''}
        id={'styled-grid-container'}
        gridGap={gridGap}
        mobileGap={mobileGap}
        justifyContent={justifyContent}
        alignItems={alignItems}
      >
        {items}
      </StyledGrid>
    </GridWrapper>
  );
};

Grid.propTypes = propTypes;

const GridWrapper = styled.div`
  overflow: visible;
  width: ${({ awardGap }) => awardGap ? `50%` : `100%`};

  @media screen and (max-width: ${media.largeBottom}) {
    width: 100%;
  }
`;

const StyledGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: ${({ gridGap }) => `-${gridGap}px 0 0 -${gridGap}px`};
  justify-content: ${({ justifyContent }) => justifyContent};
  align-items: ${({ alignItems }) => alignItems};

  @media screen and (max-width: ${media.mediumTop}) {
    margin: ${({ mobileGap }) => `-${mobileGap}px 0 0 -${mobileGap}px`};
  }

  &.no-wrap {
    flex-wrap: nowrap;
    align-items: center;

    @media screen and (max-width: ${media.mediumTop}) {
      flex-wrap: wrap;
    }
  }
`;

export { Grid };
